// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3aPNh","buttons":"PendingPaymentAlert_buttons__2RgMc"};